import { render, staticRenderFns } from "./01-Setup.vue?vue&type=template&id=74f24f84&scoped=true&"
import script from "./01-Setup.vue?vue&type=script&lang=js&"
export * from "./01-Setup.vue?vue&type=script&lang=js&"
import style0 from "./01-Setup.vue?vue&type=style&index=0&id=74f24f84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f24f84",
  null
  
)

export default component.exports